"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Icon2 = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _Select = _interopRequireDefault(require("../Select"));
var _getDebouncedMethod = _interopRequireDefault(require("../../utils/getDebouncedMethod"));
var _propsOrState = _interopRequireDefault(require("../../utils/propsOrState"));
var _Icon;
var _excluded = ["testId", "theme", "size", "optionsQuery"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var defaultProps = {
  theme: {},
  onChange: function onChange() {},
  labelKey: 'label',
  valueKey: 'value',
  itemsToFetch: 50,
  isClearedAfterSelect: false,
  validateOn: 'change',
  queryDelay: 500
};

/**
 * Extends Select component with type ahead functionality.
 * Supports all Select's props in advance.
 */
var TypeAhead = exports["default"] = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TypeAhead, _React$Component);
  function TypeAhead(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, TypeAhead);
    _this = _callSuper(this, TypeAhead, [props]);
    _this.state = _this.getInitialState();
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleInputChange = _this.handleInputChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.debouncedFetchOptions = (0, _getDebouncedMethod["default"])(_this.props.queryDelay, _this.fetchOptions.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.propsOrState = _propsOrState["default"].bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(TypeAhead, [{
    key: "getInitialState",
    value: function getInitialState() {
      return {
        options: this.props.value ? [].concat(this.props.value) : [],
        lastQuery: undefined,
        isLoading: false,
        lastPromise: undefined
      };
    }

    // TODO: remove this after fixing the Select 'value' prop
  }, {
    key: "handleChange",
    value: function handleChange(_ref) {
      var value = _ref.value,
        itemsSelected = _ref.itemsSelected;
      var _this$props = this.props,
        onChange = _this$props.onChange,
        optionsQuery = _this$props.optionsQuery,
        isClearedAfterSelect = _this$props.isClearedAfterSelect;
      var newValue = itemsSelected || value;
      this.setState(this.getInitialState());
      if (!isClearedAfterSelect) {
        this.setState({
          value: newValue
        });
      }
      onChange({
        value: newValue
      });
      // If there is a query then we must now clear the options, since
      // the list is dependent on the value typed into the text field.
      if (optionsQuery) {
        this.setState({
          options: []
        });
      }
      // Init everything again
      this.debouncedFetchOptions.cancel();
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value) {
      // Init everything again if value is empty
      if (!value) {
        this.debouncedFetchOptions.cancel();
        this.setState(this.getInitialState());
        return;
      }
      var _this$state = this.state,
        options = _this$state.options,
        isLoading = _this$state.isLoading,
        lastQuery = _this$state.lastQuery;

      // Don't issue a new query containing the previous query
      // if the previous query came back with no results
      if (!isLoading && options.length === 0 && lastQuery && value.indexOf(lastQuery) !== -1) {
        this.setState({
          lastQuery: value
        });
        return;
      }
      this.debouncedFetchOptions.init({
        value: value,
        offset: 0
      });
    }
  }, {
    key: "fetchOptions",
    value: function fetchOptions(_ref2) {
      var _this2 = this;
      var value = _ref2.value,
        offset = _ref2.offset;
      var _this$props2 = this.props,
        optionsQuery = _this$props2.optionsQuery,
        itemsToFetch = _this$props2.itemsToFetch;
      var promise = new Promise(function (resolve, reject) {
        if (optionsQuery) {
          optionsQuery({
            offset: offset,
            query: value,
            limit: itemsToFetch
          }).then(resolve)["catch"](reject);
        } else {
          resolve([]);
        }
      });
      this.setState({
        isLoading: true,
        lastPromise: promise
      });
      return promise.then(function (result) {
        if (promise === _this2.state.lastPromise) {
          _this2.setState({
            options: result,
            lastQuery: value,
            isLoading: false
          });
        }
      })["catch"](function () {
        _this2.setState({
          isLoading: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state2 = this.state,
        isLoading = _this$state2.isLoading,
        options = _this$state2.options,
        lastQuery = _this$state2.lastQuery;
      var _this$props3 = this.props,
        testId = _this$props3.testId,
        theme = _this$props3.theme,
        size = _this$props3.size,
        optionsQuery = _this$props3.optionsQuery,
        others = (0, _objectWithoutProperties2["default"])(_this$props3, _excluded);
      // If there is an options query, then the options list may dynamically
      // change, and so we must not enforce that selected items are in the
      // options list:
      var optionsListEnforced = !optionsQuery;

      // The value will come from the props if it was hard-coded, or from
      // state if it came from the autocompletion list:
      var value = this.propsOrState('value');

      // Force the menu to be closed if lastQuery is empty (initial state)
      var isOpen = !lastQuery ? false : undefined;
      delete others.onChange;
      delete others.onInputChange;
      return /*#__PURE__*/_react["default"].createElement(_Select["default"], (0, _extends2["default"])({
        arrowRenderer: TypeAhead.arrowRenderer,
        className: (0, _classnames["default"])(theme.typeahead),
        "data-anypoint-component": TypeAhead.displayName,
        testId: testId,
        isLoading: isLoading,
        isOpen: isOpen,
        onChange: this.handleChange,
        onInputChange: this.handleInputChange,
        options: options,
        optionsListEnforced: optionsListEnforced,
        filterOptions: false,
        theme: theme.Select,
        value: value,
        size: size
      }, others));
    }
  }], [{
    key: "arrowRenderer",
    value: function arrowRenderer() {
      return _Icon || (_Icon = /*#__PURE__*/_react["default"].createElement(_Icon2["default"], {
        name: "search",
        size: "",
        isDecorative: true
      }));
    }
  }]);
  return TypeAhead;
}(_react["default"].Component);
(0, _defineProperty2["default"])(TypeAhead, "defaultProps", defaultProps);
(0, _defineProperty2["default"])(TypeAhead, "displayName", 'TypeAhead');
//# sourceMappingURL=TypeAhead.js.map